import React from 'react';
import styled from '@emotion/styled';
import { Link, Typography } from '@mui/material';

// Policy Wordings
import BroadformBuildingInsurancePolicy from '../assets/documents/products-key-information/commercial/Broadform-building-insurance-policy-2025.pdf';
import BroadformBuildingKeyInformationDocument from '../assets/documents/products-key-information/commercial/Broadform-building-KID-2025.pdf';
import CommunityLivingInsurancePolicy from '../assets/documents/products-key-information/community/Community-living-insurance-policy-2025.pdf';
import CommunityLivingKeyInformationDocument from '../assets/documents/products-key-information/community/Community-living-KID-2025.pdf';
import FidelityAndComputerCrimeInsurancePolicy from '../assets/documents/products-key-information/fidelity/Fidelity-Computer-Crime-insurance-policy-2025.pdf';
import SummaryOfChangesToFidelityComputerCrimePolicy from '../assets/documents/products-key-information/fidelity/Summary-of-Changes-to-Fidelity-Computer-Crime-Policy-November-2025.pdf';
import PrivacyPolicy from '../assets/documents/products-key-information/CIA-Privacy-Policy-03102025.pdf';
import BroadformHomeownersInsurancePolicy from '../assets/documents/products-key-information/homeowners/Broadform-homeowners-insurance-policy-2025.pdf';
import BroadformHomeownersKeyInformationDocument from '../assets/documents/products-key-information/homeowners/Broadform-homeowners-KID-2025.pdf';

//Forms
import DeclarationByManagingAgentFidelityAndComputerCrimePolicyNewBusinessAndRenewals from '../assets/documents/products-key-information/fidelity/CIA-Fidelity-Computer-Crime-Declaration-ManagingAgent.pdf';
import FidelityComputerCrimeQuotationProposalForm from '../assets/documents/products-key-information/fidelity/Fidelity-And-Computer-Crime-Quotation-Proposal-Form.pdf';
import InsuranceProposalForm2024 from '../assets/documents/products-key-information/Insurance-Proposal-Form-November 2024.pdf';
import BrokerApplicationForm from '../assets/documents/Broker-Application-Form.pdf';
import DebitOrderAuthorityForm from '../assets/documents/CIA-Debit-Order-Authority.pdf';
import CIAClaimForm from '../assets/documents/CIA-Claim-Form.pdf';
import CIAFastTrackGeyserClaimForm from '../assets/documents/CIA-Fast-Track-Geyser-Claim-Form.pdf';
import CIAFidelityComputerCrimeClaimForm from '../assets/documents/CIA-Fidelity-Computer-Crime-Claim-Form.pdf';
import CIAHotWorkPermit2023 from '../assets/documents/CIA-Hot-Works-Permit-2023.pdf';
import CIAAlternativeEnergy from '../assets/documents/CIA-Alternative-Energy-November2025.pdf';
import FGRenewalForm from '../assets/documents/FG-Renewal-Form-2025.pdf';
import CIACreditCheckConsentForm from '../assets/documents/CIA-Consent-Credit-Checks-November2025.pdf';

//Legal
import CIAObjectionRequestPOPIForm from '../assets/documents/legal/CIA-Objection-Request-POPI-Form.pdf';
import PromotionofAccesstoInformation from '../assets/documents/legal/PAIA-2025.pdf';
import CodeofConduct2025 from '../assets/documents/legal/Code-of-Conduct-2025.pdf';
import DisclosureNotice from '../assets/documents/legal/Disclosure-Notice-2025.pdf';
import TreatingCustomersFairly2025 from '../assets/documents/legal/Treating-Customers-Fairly-2025.pdf';
import ConflictOfInterestManagementPolicySep2024 from '../assets/documents/legal/Conflict of Interest Management Policy Sept 2024.pdf';
import ComplaintsPolicy from '../assets/documents/legal/Complaints-Policy.pdf';

//Other
import AverageWaiverExtension from '../assets/documents/products-key-information/community/average-waiver-flyer-march-2025.pdf';
import EnhancedGeyserBenefit from '../assets/documents/products-key-information/community/Enhanced-Geyser-Benefit.pdf';
import GeyserBrochure2024 from '../assets/documents/Geyser-Brochure-2024.pdf';
import CIA2024Brochure from '../assets/documents/CIA-2024-Brochures.pdf';

const ItemLink = styled(Link)(({ theme }) => ({
    marginBottom: '20px',
}));

const LinkContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
}));

const PolicyWordingsSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1}>
                    Policy Wordings
                </Typography>
                <ItemLink href={BroadformBuildingInsurancePolicy} target="_blank">
                    Broadform Building Insurance Policy 2025
                </ItemLink>
                <ItemLink href={BroadformBuildingKeyInformationDocument} target="_blank">
                    Broadform Building Key Information Document 2025
                </ItemLink>
                <ItemLink href={BroadformHomeownersInsurancePolicy} target="_blank">
                    Broadform Homeowners Insurance Policy 2025
                </ItemLink>
                <ItemLink href={BroadformHomeownersKeyInformationDocument} target="_blank">
                    Broadform Homeowners Key Information Document 2025
                </ItemLink>
                <ItemLink href={CommunityLivingInsurancePolicy} target="_blank">
                    Community Living Insurance Policy 2025
                </ItemLink>
                <ItemLink href={CommunityLivingKeyInformationDocument} target="_blank">
                    Community Living Key Information Document 2025
                </ItemLink>
                <ItemLink href={FidelityAndComputerCrimeInsurancePolicy} target="_blank">
                    Fidelity And Computer Crime Insurance Policy 2025
                </ItemLink>
                <ItemLink
                    href={SummaryOfChangesToFidelityComputerCrimePolicy}
                    target="_blank"
                >
                    Summary Of Changes To Fidelity Computer Crime Policy November 2025
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const FormsSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Forms
                </Typography>
                <ItemLink href={BrokerApplicationForm} target="_blank">
                    Broker Application Form
                </ItemLink>
                <ItemLink href={CIAClaimForm} target="_blank">
                    CIA Claim Form
                </ItemLink>
                <ItemLink href={CIAAlternativeEnergy} target="_blank">
                    CIA ALTERNATIVE ENERGY
                </ItemLink>
                <ItemLink href={CIAFastTrackGeyserClaimForm} target="_blank">
                    CIA Fast Track Geyser Claim Form
                </ItemLink>
                <ItemLink href={CIAFidelityComputerCrimeClaimForm} target="_blank">
                    CIA Fidelity Claim Form
                </ItemLink>
                <ItemLink href={CIAHotWorkPermit2023} target="_blank">
                    CIA Hot Work Permit
                </ItemLink>
                <ItemLink href={InsuranceProposalForm2024} target="_blank">
                    CIA Insurance Proposal November 2024
                </ItemLink>
                <ItemLink
                    href={
                        DeclarationByManagingAgentFidelityAndComputerCrimePolicyNewBusinessAndRenewals
                    }
                    target="_blank"
                >
                    Declaration By Managing Agent Fidelity And Computer Crime Policy New Business
                    And Renewals 2019
                </ItemLink>
                <ItemLink href={FidelityComputerCrimeQuotationProposalForm} target="_blank">
                    Fidelity Computer Crime Quotation Proposal Form
                </ItemLink>
                <ItemLink href={FGRenewalForm} target="_blank">
                    Fidelity And Computer Crime Renewal Form
                </ItemLink>
                <ItemLink href={DebitOrderAuthorityForm} target="_blank">
                    CIA Debit Order Authority Form
                </ItemLink>
                <ItemLink href={CIACreditCheckConsentForm} target="_blank">
                    CIA Credit Check Consent Form
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const LegalSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Legal
                </Typography>
                <ItemLink href={PrivacyPolicy} target="_blank">
                    CIA Privacy Policy 2025
                </ItemLink>
                <ItemLink href={CIAObjectionRequestPOPIForm} target="_blank">
                    CIA Objection Request POPI Form
                </ItemLink>
                <ItemLink href={PromotionofAccesstoInformation} target="_blank">
                    Promotion of Access to Information Policy
                </ItemLink>
                <ItemLink href={CodeofConduct2025} target="_blank">
                    Code of Conduct 2025
                </ItemLink>
                <ItemLink href={DisclosureNotice} target="_blank">
                    Disclosure Notice
                </ItemLink>
                <ItemLink href={TreatingCustomersFairly2025} target="_blank">
                    Treating Customers Fairly 2025
                </ItemLink>
                <ItemLink href={ConflictOfInterestManagementPolicySep2024} target="_blank">
                    Conflict of Interest Management Policy Sept 2024
                </ItemLink>
                <ItemLink href={ComplaintsPolicy} target="_blank">
                    Complaints Policy
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

const OtherSection = () => {
    return (
        <React.Fragment>
            <LinkContainer>
                <Typography variant="h5" marginBottom={1} marginTop={3}>
                    Other
                </Typography>
                <ItemLink href={AverageWaiverExtension} target="_blank">
                    Average Waiver Extension
                </ItemLink>
                <ItemLink href={CIA2024Brochure} target="_blank">
                    CIA 2024 Brochure
                </ItemLink>
                <ItemLink href={EnhancedGeyserBenefit} target="_blank">
                    Enhanced Geyser Benefit
                </ItemLink>
                <ItemLink href={GeyserBrochure2024} target="_blank">
                    Geyser Brochure 2024
                </ItemLink>
            </LinkContainer>
        </React.Fragment>
    );
};

export { PolicyWordingsSection, FormsSection, OtherSection, LegalSection };
